import WeekGrid from "./WeekGrid";

export default function Utilization() {
  return (
    <>
      <section className="sec">
        <div className="shell" style={{ display: 'grid', gridTemplateColumns: '1fr 1.15fr', gap: '80px', alignItems: 'center' }} id="utilization-layout">
          <div>
            <p className="eyebrow">Utilization</p>
            <h2 className="h-lg" style={{ marginTop: '18px', fontSize: 'clamp(34px, 5vw, 72px)', lineHeight: '.96' }}>
              From Empty Courts<br />to <span style={{ color: 'var(--lime)' }}>Fully Booked.</span>
            </h2>
            <p className="lead" style={{ marginTop: '26px', maxWidth: '480px' }}>
              Every hour a court sits empty is revenue your club will never bill. PlaySlot opens booking around the clock, fills the quiet hours with events and open play, and shows you exactly where the gaps are.
            </p>
            <div className="claims">
              <p><span className="tick" aria-hidden="true">&#10003;</span>Courts bookable around the clock, not only when the desk is staffed</p>
              <p><span className="tick" aria-hidden="true">&#10003;</span>Every court and every sport on one calendar</p>
              <p><span className="tick" aria-hidden="true">&#10003;</span>Bookings taken and paid for without a phone call</p>
            </div>
          </div>

          <div className="panel reveal">
            <div className="panel-head" style={{ flexWrap: 'wrap' }}>
              <div className="disp" style={{ fontWeight: '700', fontSize: '16px' }}>A week on the courts</div>
              <div className="legend">
                <span><i className="swatch" style={{ background: 'rgba(255,255,255,.10)' }}></i>Available</span>
                <span><i className="swatch" style={{ background: 'var(--blue)' }}></i>Reserved</span>
                <span><i className="swatch" style={{ background: 'var(--cyan)' }}></i>Peak</span>
                <span><i className="swatch" style={{ background: 'var(--lime)' }}></i>Fully booked</span>
              </div>
            </div>
            <WeekGrid />
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center', justifyContent: 'space-between', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid var(--line-soft)' }}>
              <div className="mono" style={{ fontSize: '11px', letterSpacing: '.14em', color: 'var(--ink-4)' }}>AVAILABLE &rarr; RESERVED &rarr; PEAK &rarr; FULLY BOOKED</div>
              <div className="mono" style={{ fontSize: '11px', letterSpacing: '.14em', color: 'var(--ink-5)' }}>SAMPLE FACILITY &middot; 6 COURTS</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
